
<template>
  <div id="csContainer">

  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null,
                location: null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let viewer = util.getViewer("csContainer",{
                    infoBox: true,
                    selectionIndicator: true,
                });

                this.viewer = viewer;
              let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0));
                let tileset = new Cesium.Cesium3DTileset({
                  url: '/demo/static/data/models/shp/tileset.json'
                  // url: '/demo/static/data/models/las/tileset.json',
                });

                tileset.readyPromise.then(function(tileset) {
                    viewer.scene.primitives.add(tileset);
                    viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(0.0, -0.5, tileset.boundingSphere.radius * 2.0));
                  viewer.zoomTo(tileset);

                }).otherwise(function(error) {
                    console.log(error);
                });



                // 要展示的窗体
                let nameOverlay = document.createElement('div');
                viewer.container.appendChild(nameOverlay);
                nameOverlay.className = 'backdrop';
                nameOverlay.style.display = 'none';
                nameOverlay.style.position = 'absolute';
                nameOverlay.style.bottom = '0';
                nameOverlay.style.left = '0';
                nameOverlay.style['pointer-events'] = 'none';
                nameOverlay.style.padding = '4px';
                nameOverlay.style.backgroundColor = 'black';

                // 当前选中要素
                let selected = {
                    feature: undefined,
                    originalColor: new Cesium.Color()
                };

                // 一个实体对象，它将保存有关当前选定功能的信息以供信息框显示
                var selectedEntity = new Cesium.Entity();

                // 鼠标左键点击事件
                var clickHandler = viewer.screenSpaceEventHandler.getInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);


                if (Cesium.PostProcessStageLibrary.isSilhouetteSupported(viewer.scene)) {
                    // 检测边缘
                    var silhouetteBlue = Cesium.PostProcessStageLibrary.createEdgeDetectionStage();
                    silhouetteBlue.uniforms.color = Cesium.Color.BLUE;
                    silhouetteBlue.uniforms.length = 0.01;
                    silhouetteBlue.selected = [];

                    var silhouetteGreen = Cesium.PostProcessStageLibrary.createEdgeDetectionStage();
                    silhouetteGreen.uniforms.color = Cesium.Color.LIME;
                    silhouetteGreen.uniforms.length = 0.01;
                    silhouetteGreen.selected = [];

                    viewer.scene.postProcessStages.add(Cesium.PostProcessStageLibrary.createSilhouetteStage([silhouetteBlue, silhouetteGreen]));

                    // 悬停变蓝
                    viewer.screenSpaceEventHandler.setInputAction(function onMouseMove(movement) {
                        // 如果先前高亮显示了某个要素，请撤消该高亮显示
                        silhouetteBlue.selected = [];
                        // 选取新要素
                        var pickedFeature = viewer.scene.pick(movement.endPosition);
                        if (!Cesium.defined(pickedFeature)) {
                            nameOverlay.style.display = 'none';
                            return;
                        }

                        // A feature was picked, so show it's overlay content
                        // nameOverlay.style.display = 'block';
                        nameOverlay.style.bottom = viewer.canvas.clientHeight - movement.endPosition.y + 'px';
                        nameOverlay.style.left = movement.endPosition.x + 'px';
                        var name = pickedFeature.getProperty('id');

                        // if (!Cesium.defined(name)) {
                        //     name = pickedFeature.getProperty('id');
                        // }
                        nameOverlay.textContent = name;
                        // Highlight the feature if it's not already selected.
                        if (pickedFeature !== selected.feature) {
                            silhouetteBlue.selected = [pickedFeature];
                        }
                    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

                    // Silhouette a feature on selection and show metadata in the InfoBox.
                    viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement) {
                        // If a feature was previously selected, undo the highlight
                        silhouetteGreen.selected = [];

                        // Pick a new feature
                        var pickedFeature = viewer.scene.pick(movement.position);
                        if (!Cesium.defined(pickedFeature)) {
                            clickHandler(movement);
                            return;
                        }

                        // Select the feature if it's not already selected
                        if (silhouetteGreen.selected[0] === pickedFeature) {
                            return;
                        }

                        // Save the selected feature's original color
                        var highlightedFeature = silhouetteBlue.selected[0];
                        if (pickedFeature === highlightedFeature) {
                            silhouetteBlue.selected = [];
                        }

                        // Highlight newly selected feature
                        silhouetteGreen.selected = [pickedFeature];

                        // Set feature infobox description
                        var featureName = pickedFeature.getProperty('id');
                        selectedEntity.name = featureName;
                        selectedEntity.description = 'Loading <div class="cesium-infoBox-loading"></div>';
                        viewer.selectedEntity = selectedEntity;
                        selectedEntity.description = '<table class="cesium-infoBox-defaultTable"><tbody>' +
                            '<tr><th>ID</th><td>' + featureName + '</td></tr>' +
                            '<tr><th>height</th><td>' + pickedFeature.getProperty('height') + '</td></tr>' +                       
                           
                            '</tbody></table>';
                    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
                } else {
                    // Silhouettes are not supported. Instead, change the feature color.

                    // Information about the currently highlighted feature
                    var highlighted = {
                        feature : undefined,
                        originalColor : new Cesium.Color()
                    };

                    // Color a feature yellow on hover.
                    viewer.screenSpaceEventHandler.setInputAction(function onMouseMove(movement) {
                        // If a feature was previously highlighted, undo the highlight
                        if (Cesium.defined(highlighted.feature)) {
                            highlighted.feature.color = highlighted.originalColor;
                            highlighted.feature = undefined;
                        }
                        // Pick a new feature
                        var pickedFeature = viewer.scene.pick(movement.endPosition);
                        if (!Cesium.defined(pickedFeature)) {
                            nameOverlay.style.display = 'none';
                            return;
                        }
                        // A feature was picked, so show it's overlay content
                        nameOverlay.style.display = 'block';
                        nameOverlay.style.bottom = viewer.canvas.clientHeight - movement.endPosition.y + 'px';
                        nameOverlay.style.left = movement.endPosition.x + 'px';
                        var name = pickedFeature.getProperty('name');
                        if (!Cesium.defined(name)) {
                            name = pickedFeature.getProperty('id');
                        }
                        nameOverlay.textContent = name;
                        // Highlight the feature if it's not already selected.
                        if (pickedFeature !== selected.feature) {
                            highlighted.feature = pickedFeature;
                            Cesium.Color.clone(pickedFeature.color, highlighted.originalColor);
                            pickedFeature.color = Cesium.Color.YELLOW;
                        }
                    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

                    // Color a feature on selection and show metadata in the InfoBox.
                    viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement) {
                        // If a feature was previously selected, undo the highlight
                        if (Cesium.defined(selected.feature)) {
                            selected.feature.color = selected.originalColor;
                            selected.feature = undefined;
                        }
                        // Pick a new feature
                        var pickedFeature = viewer.scene.pick(movement.position);
                        if (!Cesium.defined(pickedFeature)) {
                            clickHandler(movement);
                            return;
                        }
                        // Select the feature if it's not already selected
                        if (selected.feature === pickedFeature) {
                            return;
                        }
                        selected.feature = pickedFeature;
                        // Save the selected feature's original color
                        if (pickedFeature === highlighted.feature) {
                            Cesium.Color.clone(highlighted.originalColor, selected.originalColor);
                            highlighted.feature = undefined;
                        } else {
                            Cesium.Color.clone(pickedFeature.color, selected.originalColor);
                        }
                        // Highlight newly selected feature
                        pickedFeature.color = Cesium.Color.LIME;
                        // Set feature infobox description
                        var featureName = pickedFeature.getProperty('name');
                        selectedEntity.name = featureName;
                        selectedEntity.description = 'Loading <div class="cesium-infoBox-loading"></div>';
                        viewer.selectedEntity = selectedEntity;
                        selectedEntity.description = '<table class="cesium-infoBox-defaultTable"><tbody>' +
                            '<tr><th>BIN</th><td>' + pickedFeature.getProperty('BIN') + '</td></tr>' +
                            '<tr><th>DOITT ID</th><td>' + pickedFeature.getProperty('DOITT_ID') + '</td></tr>' +
                            '<tr><th>SOURCE ID</th><td>' + pickedFeature.getProperty('SOURCE_ID') + '</td></tr>' +
                            '<tr><th>Longitude</th><td>' + pickedFeature.getProperty('longitude') + '</td></tr>' +
                            '<tr><th>Latitude</th><td>' + pickedFeature.getProperty('latitude') + '</td></tr>' +
                            '<tr><th>Height</th><td>' + pickedFeature.getProperty('height') + '</td></tr>' +
                            '<tr><th>Terrain Height (Ellipsoid)</th><td>' + pickedFeature.getProperty('TerrainHeight') + '</td></tr>' +
                            '</tbody></table>';
                    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
                }


            },


        }
    }
</script>
<style scoped>
    .speed{
        position: absolute;
        width:200px;
        margin-left: 25px;
        margin-top:7px;
        z-index: 999;
    }
    .submit {
        position: absolute;

        margin-left: 232px;
        margin-top:7px;
        z-index: 999;
    }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
